
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 12.9 12.2","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('style',[_v('.st0{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}')]),_c('path',{staticClass:"st0",attrs:{"d":"M6.5 1.2l5 5-5 5M11.5 6.2h-10"}})])
          )
        }
      }
    